import { sessionApiClient } from "@planningcenter/cc-api-client"
import { queryOptions, replaceEqualDeep, useQuery } from "@tanstack/react-query"

import { useShouldSubscribeToPublishingJoltEvents } from "source/publishing/ReactToPublishingJoltEvents"
import {
  WEB_BOOT_PATH,
  mapApiResponseToStateShape,
  setLocalWebBootState,
  webBootDataDifferent,
  WebBootState,
} from "source/publishing/WebBoot/webBootState"

const WEB_BOOT_POLLING_INTERVAL = 5 * 60 * 1000

export const webBootQueryOptions = queryOptions<WebBootState>({
  queryKey: ["webBoot"],
  staleTime: 60 * 1000,
  queryFn: () =>
    sessionApiClient
      .get(WEB_BOOT_PATH)
      .then(mapApiResponseToStateShape)
      .then((webBootState: WebBootState) => {
        setLocalWebBootState(webBootState)
        return webBootState
      }),
  structuralSharing: (oldData, newData) =>
    oldData &&
    !webBootDataDifferent(oldData as WebBootState, newData as WebBootState)
      ? oldData
      : replaceEqualDeep(oldData, newData),
})

export function useWebBootQuery(
  initialState: WebBootState | null,
  initialStateIsFresh: boolean = false,
) {
  const useJoltToUpdate = useShouldSubscribeToPublishingJoltEvents()

  const { data: webBootData, refetch: refetchWebBoot } = useQuery({
    ...webBootQueryOptions,
    refetchInterval: !useJoltToUpdate && WEB_BOOT_POLLING_INTERVAL,
    refetchOnWindowFocus: !useJoltToUpdate,
    refetchOnReconnect: !useJoltToUpdate,
    initialData: initialState ?? undefined,
    initialDataUpdatedAt: () => (initialStateIsFresh ? Date.now() : 0),
  })

  return { webBootData, refetchWebBoot }
}
